import { HTMLAttributes, forwardRef } from 'react';
import { cn } from '../../lib/cn';

export interface ContainerProps extends HTMLAttributes<HTMLDivElement> {
  size?: 'narrow' | 'default' | 'wide' | 'full';
}

export const Container = forwardRef<HTMLDivElement, ContainerProps>(
  ({ className, size = 'default', children, ...props }, ref) => {
    const sizes = {
      narrow: 'container-narrow',
      default: 'max-w-6xl mx-auto px-4 sm:px-6',
      wide: 'container-wide',
      full: 'container-full',
    };

    return (
      <div ref={ref} className={cn(sizes[size], className)} {...props}>
        {children}
      </div>
    );
  }
);

Container.displayName = 'Container';
